import React from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import * as demoStoreActions from '../../../../actions/admin/demoStoreActions';
import * as globalMessageActions from '../../../../actions/globalMessageActions';
import validator from 'validator';

import { connect } from 'react-redux';
import FormElement from '../../../shared/form/FormElement';
import ClientsDropbox from '../../../shared/dropbox/ClientsDropbox';
import CampaignDropbox from '../../../shared/dropbox/CampaignDropbox';
import CampaignVersionDropbox from '../../../shared/dropbox/CampaignVersionDropbox';
import EnvironmentDropbox from '../../../shared/dropbox/EnvironmentDropbox';

@connect((store) => {
  return {
    demoStoreNew: store.adminDemoStore.demoStoreNew
  };
})

class DemoStoreCreate extends React.Component {

  constructor(props) {
    super(props);

    const {
      demoStoreDetails = {
        clientId:'',
        clientName: '',
        environment: '',
        notes: '',
        storeName: '',
        storeLink: '',
        campaignId: '',
        campaignName: '',
        campaignVersionId: '',
        campaignVersionName: '',
        country: '',
        emailAvailable: '',
        firstNameAvailable: ''
      }
    } = props;

    this.state = {
      demoStoreDetails,
      errors: {},
      displayErrorMessage: false,
      formSuccessfullySubmitted: false,
    };

    this.onClientChange = this.onClientChange.bind(this);
    this.onCampaignChange = this.onCampaignChange.bind(this);
    this.onCampaignVersionChange = this.onCampaignVersionChange.bind(this);
    this.onEnvironmentChange = this.onEnvironmentChange.bind(this);
  }

  componentWillUpdate(nextProps){
    if(this.props.demoStoreNew !== nextProps.demoStoreNew){
      if(_.get(nextProps,'demoStoreNew.data')){
        this.props.dispatch(globalMessageActions.showMessage({
          type: 'error',
          message: 'Error: ' + nextProps.demoStoreNew.data.message,
          timeout: 10000
        }));
      }
    }
  }

  onChange(name, { target }) {
    const { demoStoreDetails } = this.state;
    _.set(demoStoreDetails, name, target.value);
    this.setState({ demoStoreDetails });
  }

  onClientChange(e){

    const { demoStoreDetails } = this.state;

    if (e.value && e.value !== null) {
      _.set(demoStoreDetails, 'clientId', e.value);
      _.set(demoStoreDetails, 'clientName', e.originalEvent.target.innerText);
      _.set(demoStoreDetails, 'campaignId', null);
      _.set(demoStoreDetails, 'campaignName', '');
      _.set(demoStoreDetails, 'campaignVersionId', null);
      _.set(demoStoreDetails, 'campaignVersionName', '');
    } else {
      _.set(demoStoreDetails, 'clientId', '');
      _.set(demoStoreDetails, 'clientName', '');
      _.set(demoStoreDetails, 'campaignId', null);
      _.set(demoStoreDetails, 'campaignName', '');
      _.set(demoStoreDetails, 'campaignVersionId', null);
      _.set(demoStoreDetails, 'campaignVersionName', '');
    }

    this.setState({ demoStoreDetails });
  }

  onCampaignChange(e){
    const {demoStoreDetails} = this.state;
    _.set(demoStoreDetails, 'campaignId', e.value);
    _.set(demoStoreDetails, 'campaignName', e.originalEvent.target.innerText);
    _.set(demoStoreDetails, 'campaignVersionId', null);
    _.set(demoStoreDetails, 'campaignVersionName', '');
    this.setState({demoStoreDetails});
  }

  onCampaignVersionChange(e){
    const {demoStoreDetails} = this.state;
    _.set(demoStoreDetails, 'campaignVersionId', e.value);
    _.set(demoStoreDetails, 'campaignVersionName', e.originalEvent.target.innerText);
    this.setState({demoStoreDetails});
  }

  onEnvironmentChange(e) {
    const { demoStoreDetails } = this.state;
    _.set(demoStoreDetails, 'environment', e.value);
    this.setState({ demoStoreDetails });
  }

  onSubmit(){
    this.setState({ displayErrorMessage: false });
    const { demoStoreDetails, errors } = this.state;
    let checkErrors = false;

    this.validateForm();

    for( const key in errors ) {
      if( errors[key] ) {
        checkErrors = true;
        this.setState({ displayErrorMessage: true });
        this.props.dispatch(globalMessageActions.showMessage({
          type: 'error',
          message: 'Please fill all the required',
          timeout: 10000
        }));
        break;
      }
    }

    if( !checkErrors ) {
      this.props.dispatch(demoStoreActions.newDemoStore(demoStoreDetails))
        .then(created => browserHistory.push({ pathname: `/admin/demoStore/${created._id}` , state: { fromCreatePage: true } }));

    }

    console.log(errors); //for debugging left in for internal use only as it is an admin tool.

  }

  validateForm() {
    const { demoStoreDetails, errors } = this.state;

    errors[ 'storeName' ] = validator.isEmpty(demoStoreDetails.storeName);
    errors[ 'storeLink' ] = validator.isEmpty(demoStoreDetails.storeLink);
    errors[ 'clientId' ] = validator.isEmpty(demoStoreDetails.clientId.toString());
    errors[ 'campaingId' ] = false;
    errors[ 'campaignVersionId' ] = false;
    errors[ 'country' ] = false;
    errors[ 'firstNameAvailable' ] = validator.isEmpty(demoStoreDetails.firstNameAvailable);
    errors[ 'emailAvailable' ] = validator.isEmpty(demoStoreDetails.emailAvailable);
    errors[ 'environment' ] = validator.isEmpty(demoStoreDetails.environment);

    return this.setState({ errors });
  }

  render (){
    const { demoStoreDetails = { info: {} }, errors } = this.state;

    const {
      clientId,
      storeName,
      storeLink,
      environment,
      notes,
      campaignVersionId,
      campaignId,
      country,
      firstNameAvailable,
      emailAvailable
    } = demoStoreDetails;

    return (
      <div className="campaign-new-campaign">
        <h3>Create demo store</h3>
        <form  className="c-form--flex">

          <FormElement
            label='Store Name'
            name='storeName'
            type='text'
            value={storeName}
            onChange={this.onChange.bind(this, 'storeName')}
            error={errors.storeName}
            id='form-storeName'
            required
          />

          <FormElement
            label='Store Link'
            name='storeLink'
            type='input'
            onChange={this.onChange.bind(this, 'storeLink')}
            value={storeLink}
            error={errors.storeLink}
            id='form-storeLink'
            required
          />

          <ClientsDropbox
            label="Client"
            required='true'
            onChange={this.onClientChange}
            error={errors.clientId}
          />

          <FormElement
            label='Client Id'
            name='clientId'
            type='text'
            onChange={this.onChange.bind(this, 'clientId')}
            value={clientId}
            error={errors.clientId}
            id='form-clientId'
            disabled
            required
          />

          <CampaignDropbox
            client={this.state.demoStoreDetails.clientId}
            onChange={this.onCampaignChange}
            error={errors.campaignId}
            value={campaignId}
          />

          <CampaignVersionDropbox
            campaign={this.state.demoStoreDetails.campaignId}
            onChange={this.onCampaignVersionChange}
            error={errors.campaignVersionId}
            value={campaignVersionId}
          />

          <FormElement
            label='Country'
            name='country'
            type='select'
            onChange={this.onChange.bind(this, 'country')}
            value={country}
            error={errors.country}
            id='form-country'
          >
            <option value=""> </option>
            <option value="GB">GB</option>
            <option value="IE">IE</option>
            <option value="FR">FR</option>
            <option value="DE">DE</option>
          </FormElement>

          <FormElement
            label='Email available'
            name='emailAvailable'
            type='select'
            onChange={this.onChange.bind(this, 'emailAvailable')}
            value={emailAvailable}
            error={errors.emailAvailable}
            id='form-email-available'
            required
          >
            <option value=""> </option>
            <option value="true">true</option>
            <option value="false">false</option>
          </FormElement>

          <FormElement
            label='First name available'
            name='firstNameAvailable'
            type='select'
            onChange={this.onChange.bind(this, 'firstNameAvailable')}
            value={firstNameAvailable}
            error={errors.firstNameAvailable}
            id='form-first-name-available'
            required
          >
            <option value=""> </option>
            <option value="true">true</option>
            <option value="false">false</option>
          </FormElement>

          <EnvironmentDropbox
            label="Environment"
            name='environment'
            required
            value={environment}
            onChange={ (e) => this.onEnvironmentChange(e) }
            error={errors.environment}
          />

          <FormElement
            label='Notes'
            name='notes'
            type='textArea'
            onChange={this.onChange.bind(this, 'notes')}
            value={notes}
            error={errors.notes}
            id='form-notes'
          />

        </form>
        <br />
        <button style={{ marginTop: '10px' }} onClick={()=>this.onSubmit()}>Create demo store</button>

        <button
          className="button icon-left"
          onClick={browserHistory.goBack}>
          Back
        </button>
      </div>
    );
  }
}

export default DemoStoreCreate;